import { TinyColor } from '@ctrl/tinycolor';
import type { BdColorFactoryType } from './color-factory';
import { BdColorFactory } from './color-factory';

export class BdColorLightnessFactory extends BdColorFactory {
  type: BdColorFactoryType = 'lightness';

  public static fromObject(
    obj: BdColorLightnessFactoryOptions,
  ): BdColorLightnessFactory {
    const color =
      !!obj && !!obj.color
        ? new TinyColor(obj.color)
        : new TinyColor('hsl(0, 100%, 50%)');

    return new BdColorLightnessFactory(color);
  }

  constructor(public color: TinyColor) {
    super();
  }

  override clone(): BdColorLightnessFactory {
    return new BdColorLightnessFactory(this.color.clone());
  }

  toJSON(): BdColorLightnessFactoryOptions {
    return {
      type: this.type,
      color: this.color.toHslString(),
    };
  }

  getColorForValue(
    value: number,
    minValue: number,
    maxValue: number,
  ): TinyColor {
    let targetColor: TinyColor;

    if (value === minValue) {
      targetColor = new TinyColor('#ffffff');
    } else if (value === maxValue) {
      targetColor = this.color;
    } else {
      const hsl = this.color.toHsl();
      const lightenRange = 1 - this.color.toHsl().l;
      const percentage = 1 - this.percentage(value, minValue, maxValue);

      hsl.l = hsl.l + lightenRange * percentage;

      targetColor = new TinyColor(hsl);
    }

    return targetColor;
  }

  equals(other: BdColorFactory): boolean {
    switch (other.type) {
      case 'lightness': {
        return this.color.equals((other as BdColorLightnessFactory).color);
      }
      default: {
        return false;
      }
    }
  }
}

export interface BdColorLightnessFactoryOptions {
  type: BdColorFactoryType;
  color: string;
}
